import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=1c231d91&scoped=true&"
import script from "./NewAccount.vue?vue&type=script&lang=js&"
export * from "./NewAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAccount.vue?vue&type=style&index=0&id=1c231d91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c231d91",
  null
  
)

export default component.exports